import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Configure axios to include credentials (for HttpOnly cookies)
axios.defaults.withCredentials = true;

// Note: Authorization header is set globally by AuthContext when token changes
// No need to manually add headers to each request

export const quotesApi = {
  list: (filters = {}) => axios.get(`${API}/quotes`, { params: filters }).then(r => r.data),
  get: (id) => axios.get(`${API}/quotes/${id}`).then(r => r.data),
  create: (data) => axios.post(`${API}/quotes`, data).then(r => r.data),
  update: (id, data) => axios.put(`${API}/quotes/${id}`, data).then(r => r.data),
  delete: (id) => axios.delete(`${API}/quotes/${id}`).then(r => r.data),
  archive: (id, archived = true) => axios.put(`${API}/quotes/${id}/archive`, null, { 
    params: { archived }
  }).then(r => r.data),
  createNewVersion: (id) => axios.post(`${API}/quotes/${id}/new-version`).then(r => r.data),
  updateStatus: (id, status) => axios.put(`${API}/quotes/${id}/status`, null, { 
    params: { status }
  }).then(r => r.data),
  getVersions: (id) => axios.get(`${API}/quotes/${id}/versions`).then(r => r.data),
};

export const usersApi = {
  listForFilter: () => axios.get(`${API}/users/list`).then(r => r.data),
};

export const adminApi = {
  getOverride: (type) => axios.get(`${API}/admin/overrides/${type}`).then(r => r.data),
  saveOverride: (type, data) => axios.put(`${API}/admin/overrides/${type}`, { type, data }).then(r => r.data),
  resetOverride: (type) => axios.delete(`${API}/admin/overrides/${type}`).then(r => r.data),
  listUsers: () => axios.get(`${API}/admin/users`).then(r => r.data),
  updateUserRole: (userId, role) => axios.put(`${API}/admin/users/${userId}/role`, null, { 
    params: { role }
  }).then(r => r.data),
  toggleUserStatus: (userId, isActive) => axios.put(`${API}/admin/users/${userId}/status`, null, { 
    params: { is_active: isActive }
  }).then(r => r.data),
  updateDiscountLevel: (userId, level) => axios.put(`${API}/admin/users/${userId}/discount-level`, null, {
    params: { level }
  }).then(r => r.data),
  getDiscountLimits: () => axios.get(`${API}/discount-limits`).then(r => r.data),
};

// Calculation API - Server-side pricing calculations
export const calculationApi = {
  // Calculate all costs for a quote
  calculate: (data) => axios.post(`${API}/calculate`, data).then(r => r.data),
  
  // Get WC rate for specific state and class code
  getWcRate: (state, classCode) => axios.get(`${API}/rates/wc/${state}/${classCode}`).then(r => r.data),
  
  // Get SUTA rate for specific state
  getSutaRate: (state) => axios.get(`${API}/rates/suta/${state}`).then(r => r.data),
  
  // Get all SUTA wage bases
  getSutaBases: () => axios.get(`${API}/rates/suta-bases`).then(r => r.data),
  
  // Get all SUTA rates
  getSutaRates: () => axios.get(`${API}/rates/suta-rates`).then(r => r.data),
  
  // Get all WC codes for a state
  getWcCodes: (state) => axios.get(`${API}/rates/wc-codes/${state}`).then(r => r.data),
  
  // Get list of all states
  getStates: () => axios.get(`${API}/rates/states`).then(r => r.data),
  
  // Get monopolistic states
  getMonopolisticStates: () => axios.get(`${API}/rates/monopolistic-states`).then(r => r.data),
  
  // Validate discount
  validateDiscount: (standardRate, proposedRate, maxDiscountPct = 10) => 
    axios.post(`${API}/rates/validate-discount`, null, {
      params: { standard_rate: standardRate, proposed_rate: proposedRate, max_discount_pct: maxDiscountPct }
    }).then(r => r.data),
};
